<template>
    <div class="main_body">

        <div class="input_search mb-4">
            <input v-model="model_find" @keypress.enter="findname" type="text" placeholder="Search" class="form-control">
            <svg @click="findname" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#9F9F9F"/>
            </svg>
        </div>
        <div class="d-flex justify-content-between">
            <div>
                <button @click="addVideo" class="btn btn-primary">+ UPLOAD</button>
                <button @click.prevent="deleteVideoGroup" class="btn" :class="[ btn_delete_all ? 'btn-border-light' : 'btn-border']">DELETE</button>
            </div>
            <div>
                <button @click.prevent="analyzeVideoGroup" class="btn" :class="[ btn_analyze_all ? 'btn-border-light' : 'btn-border']">ANALYZE</button>
            </div>
        </div>

<!--        {{sort}}:{{sorttype}}-->

        <table class="table mt-5 fz08">
            <tr class="fz08">
                <th>id</th>
                <th>
                    <div class="d-flex align-items-center">
                        <div class="">
                            <input v-model="model_all" @change="checkAll" id="top" type="checkbox" class="custom_checkbox">
                            <label for="top"></label>
                        </div>
                        <span @click="sortName" class="cursor_pointer">
                            <iconsort :updown="sort_name"></iconsort>
                            <span>Name</span>
                        </span>
                    </div>
                </th>                
                <th>
                    <span @click="sortDate" class="cursor_pointer">
                        <iconsort :updown="sort_date"></iconsort>
                        <span>Upload date</span>
                    </span>
                </th>
                <th>Begin time</th>
                <th>End time</th>
                <th>Description</th>
                <th>
                    <span @click="sortSize" class="cursor_pointer">
                        <iconsort :updown="sort_size"></iconsort>
                        <span>Size</span>
                    </span>
                </th>
                <th>
                    <span @click="sortStatus" class="cursor_pointer">
                        <iconsort :updown="sort_status"></iconsort>
                        <span>Status</span>
                    </span>
                </th>
                <th></th>
            </tr>
            <tr 
                v-for="(video, key) in videosItem" 
                :key="'videoItemListKey_' + video.id" 
                class="black_line" 
                :class="[( video.status_id === 4 ) ? 'black_line_done' : '']"                
            >
                <td @click="testUpdate(video.id)">{{video.id}}</td>
                <td>
                    <div class="avatar_and_title d-flex justify-content-start">
                        <div class="cb d-flex align-items-center">
                            <input v-model="video.checked" @change="changeItem" :id="`t_${key}`" type="checkbox" class="custom_checkbox">
                            <label :for="`t_${key}`" class="mb-0"></label>
                            <span
                                class="tableReportNameWrap video-name-link cursor_pointer"
                                :title="'Play ' + video.name"
                                @click.stop="openVideoPlayer(video)"
                            >{{ video.name }}</span>
                        </div>
                    </div>
                </td>                
                <td>{{video.created_at}}</td>
                <td class="text-center beginTime">{{video.humanBeginTime}}</td>
                <td class="text-center">{{video.humanEndTime}}</td>
                <td>{{video.description}}</td>
                <td>{{video.size}}</td>
                <td>
                    <statusvideo
                        :v_id="video.id"
                        :status_prop="video.status"                        
                        :statuses="statuses"
                        :personsnum="video.personsnum ? video.personsnum : 0"
                        :defreportlink="video.defreportlink ? video.defreportlink : '#'" 
                        :lastreportid="video.lastreportid"
                        :description_prop="video.description"
                    ></statusvideo>
                </td>
                <td>
                    <div class="dotscontrol" >
                        <div class="dotscontrol_dots" type="button" :id="`dropdownMenuButton${key}`" data-bs-toggle="dropdown" aria-expanded="false">
                            <span class="dotscontrol_dots__span"></span>
                        </div>
                        <ul class="dropdown-menu" :aria-labelledby="`dropdownMenuButton${key}`">
                            <li><a @click="editVideo(video)" class="dropdown-item" href="#">EDIT</a></li>
                            <li> <a @click="deleteVideo(video.id)" class="dropdown-item" >DELETE</a></li>
                        </ul>
                    </div>
                </td>
            </tr>

        </table>

        <div class="bottom_panel d-flex align-items-center justify-content-between mt-5">
            <div class="upload_group upload_group_sm upload_group_bottom w-100">
                <div class="black_block">
                    <div class="upload_item">
                        <div class="upload_item__left">
                            <div class="upload_item__left_top">
                                <span>{{ disk.used }} Gb of {{ disk.total }} Gb</span>
                                <span>{{disk.percent}}%</span>
                            </div>
                            <div class="progress">
                                <div
                                    class="progress-bar"
                                    :class="diskBarClass"
                                    role="progressbar"
                                    :style="`width: ${disk.percent}%`"
                                    :aria-valuenow="disk.percent"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom_panel_right">
                <div class="label_and_input_line d-flex">
                    <label for="select_count_item">Show:</label>
                    <select v-model="model_counitempage" @change="getResults" id="select_count_item" class="form-select" aria-label="Default select example">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="200">100</option>
                    </select>
                </div>
                <pagin  align="center" :data="data" @pagination-change-page="changePage">
                    <span slot="prev-nav">
                        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.91456 0.958033L2.00028 7.04255L8.0848 12.9568" stroke="white" stroke-width="2"/>
                        </svg>
                    </span>
                    <span slot="next-nav">
                        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.999999 13L7 7L0.999999 1" stroke="white" stroke-width="2"/>
                        </svg>
                    </span>
                </pagin>
                <div class="label_and_input_line d-flex">
                    <label for="to_page">Move to page:</label>
                    <input @keypress.enter="event => changePage(event.target.value)" type="number" class="form-control" id="to_page" min="1">
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import {bus} from '../bus';
import axios from 'axios';
import Pagin from 'laravel-vue-pagination';
import Dotscontrol from './Dotscontrol';
import iconsort from "./iconsort";
import hrdate from "./hrdate";
import statusvideo from "./statusvideo";

export default {
    props: ['title_person'],
    data(){
        return{
            data: {},
            videos: [],
            sort: 'id',
            sorttype: 'desc',
            sort_name: 'up',
            sort_date: 'up',
            sort_size: 'up',
            sort_status: 'up',
            model_all: false,
            listdelete: [],
            progress: 50,
            model_counitempage: 10,
            btn_delete_all: true,
            btn_analyze_all: true,
            open: false,
            statuses: [],
            model_find: '',
            disk: {
                total: '',
                used: '',
                percent: ''
            },
            changePageProp: false,
            page: 1
        }
    },
    methods: {  
        testUpdate(videoId){            
            let videoArKey = this.videosItem.findIndex(video=>video.id==videoId);
            let video = this.videosItem[videoArKey];

            console.log('video from test update: ', video);
            
            // this.updateVideoStatus(videoId, null);
        },        
        updateVideoStatus(videoId, newStatusId, description = null) {
            
            let videoArKey = this.videosItem.findIndex(video=>video.id==videoId);
            let video = this.videosItem[videoArKey];
            if (!video) return;

            video.status_id = newStatusId;
            // Keep status object in sync so badges/props match status_id after CONTINUE/ANALYZE
            if (newStatusId != null && Array.isArray(this.statuses)) {
                const st = this.statuses.find(s => s.id == newStatusId);
                if (st) video.status = st;
            }
            if (description != null && description !== undefined) {
                video.description = description;
            }
        },      
        updateVideo(video, newStatusId) {
            console.log('New status id from status video component: ', newStatusId);
            video.status_id = newStatusId;
        },      
        editVideo(video){
            console.log('video from edit video: ', video);
            video.crud = 'update';
            bus.$emit('openpopup', {
                'open': true,
                'type': 'formuploadvideo',
                'crud': 'update',
                'title_form': 'Update video',                
                'videos': [video]
            });
        },
        getStatuses(){

            axios.get('/getstatuses').then((response) => {
                if(response.data){
                    this.statuses = response.data;
                }
            }).catch(function(e){
                console.log('FAILURE STATUSES!!');
                console.log(e);
            });

        },
        changePage(page) {                        
            this.page = page;
            console.log( 'change page fire' );
            this.getResults();
            window.scrollTo(0,0);
        },
        getResults(page = this.page) {
            
            console.log('get results page ', this.page);            
            
            const url = `/getvideos`;            
            let params = {                
                countitempage: this.model_counitempage,
                sort: this.sort,
                sorttype: this.sorttype,
                find: this.model_find
            };
            
            params.page = this.page;            

            axios.get(
                url,            
                {
                    params: params,
                    headers: {
                        'ContentType': 'application/json'
                    }
                }                
            ).then((response) => {
                this.data = response.data;
                
                this.videos = (response.data.data || []).map((item) => {
                    item.checked = !!item.checked;
                    item.opensetting = false;
                    item.humanBeginTime = hVue.convertTimestamp( item.start_time || item.date );
                    if( item.end_time ){
                        item.humanEndTime = hVue.convertTimestamp( item.end_time );
                    } else {
                        item.humanEndTime = '-';
                    }
                    return item;
                });

                console.log( 'this.videos list 071221', this.videos );

                // Page/filter refresh replaces rows — recompute master from visible checks.
                this.syncSelection();
                this.changePageProp = false;
            }).catch( (error) => {
                // handle error
                console.log(error);
            });
        },
        addVideo(){
            bus.$emit('openpopup', {
                'open': true,
                'type': 'formuploadvideo',
                'crud': 'create',
                'title_form': 'Upload video',
            })
        },
        openVideoPlayer(video){
            if (!video || !video.id) {
                return;
            }
            bus.$emit('openpopup', {
                open: true,
                type: 'videoplayer',
                title_form: video.name || ('Video ' + video.id),
                video: video,
                addPopupClass: 'camera-stream-popup',
            });
        },
        sortName(){
            this.sort = 'name';
            if(this.sort_name === 'up'){
                this.sort_name = 'down';
                this.sorttype = 'desc';
            }else{
                this.sort_name = 'up';
                this.sorttype = 'asc';
            }
            this.getResults();
        },
        sortDate(){
            this.sort = 'date';
            if(this.sort_date === 'up'){
                this.sort_date = 'down';
                this.sorttype = 'desc';
            }else{
                this.sort_date = 'up';
                this.sorttype = 'asc';
            }
            this.getResults();
        },
        sortStatus(){
            this.sort = 'status_id';
            if(this.sort_status === 'up'){
                this.sort_status = 'down';
                this.sorttype = 'desc';
            }else{
                this.sort_status = 'up';
                this.sorttype = 'asc';
            }
            this.getResults();
        },
        sortSize(){
            this.sort = 'size';
            if(this.sort_size === 'up'){
                this.sort_size = 'down';
                this.sorttype = 'desc';
            }else{
                this.sort_size = 'up';
                this.sorttype = 'asc';
            }
            this.getResults();
        },
        syncSelection(){
            this.listdelete = [];
            this.videos.forEach((item) => {
                if (item.checked) {
                    this.listdelete.push(item.id);
                }
            });
            this.model_all = this.videos.length > 0
                && this.videos.every((item) => item.checked);
            const anyChecked = this.listdelete.length > 0;
            this.btn_delete_all = !anyChecked;
            this.btn_analyze_all = !anyChecked;
        },
        checkAll(){
            const checked = !!this.model_all;
            this.videos.forEach((item) => {
                item.checked = checked;
            });
            this.syncSelection();
        },
        changeItem(){
            this.syncSelection();
        },
        convertUnixTime(unix_timestamp){
            let date = new Date(unix_timestamp * 1000);
            let day = date.getDate();
            let month = date.getMonth()+1;
            let year = date.getFullYear();
            let hours = date.getHours();
            let minutes = "0" + date.getMinutes();
            let seconds = "0" + date.getSeconds();
            if( day === 1 ||
                day === 2 ||
                day === 3 ||
                day === 4 ||
                day === 5 ||
                day === 6 ||
                day === 7 ||
                day === 8 ||
                day === 9){
                day = '0'+day;
            }
            if( month === 1 ||
                month === 2 ||
                month === 3 ||
                month === 4 ||
                month === 5 ||
                month === 6 ||
                month === 7 ||
                month === 8 ||
                month === 9){
                month = '0'+month;
            }
            let formattedTime = day+ ':' +month+ ':' +year+ ' ' +hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
            return formattedTime;
        },
        deleteVideoGroup(){
            axios.post('/deletevideos',
                {
                    videos: this.listdelete
                }
            ).then((responce)=>{
                this.getResults();
                this.model_all = false;
            }).catch(function(){
                console.log('FAILURE!!');
            });
        },
        analyzeVideoGroup(){
            this.listdelete.map((item) => {
                bus.$emit('analyze_group', item);
            });
        },
        deleteVideo(video_id){
            axios.post('/deletevideos',
                {
                    id: video_id
                }
            ).then((responce)=>{
                this.getResults();
                this.model_all = false;
            }).catch(function(){
                console.log('FAILURE!!');
            });
        },
        openSettings(key){
            this.videos.map((item, keyitem) => {
                if(key === keyitem){
                    item.opensetting = true;
                }
            });
            // console.log(this.videos);
        },
        getDisk(){
            axios.get('/videos/share').then((responce)=>{
                console.log('typeof', responce.data);
                if(responce.data){                
                    let disk = responce.data;                
                    this.disk.total = Math.trunc(disk.total);
                    this.disk.used = Math.trunc(disk.used);
                    this.disk.percent = disk.percent;                
                }
            }).catch(function(){
                console.log('DISK FAILURE!!');
            });
        },
        findname(){
            this.getResults();
        }
    },
    mounted(){
        this.getDisk();
        this.getStatuses();
        this.getResults();
        bus.$on('addcategory', (data) => {            
            let token = document.head.querySelector('meta[name="csrf-token"]');
            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;

            axios.post('/categories', data)
                .then(function (response) {
                    // handle success
                    // console.log('handle success', response.data);
                    // if(response.data.name){
                        this.data.push(response.data);


                        // console.log(this.data)
                    // }
                    // this.getCategories();
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
        });
        bus.$on('getvideos', (data) => {
            if(data){
                this.getResults();
            }
        });
        bus.$on('updatevideolist', (data) => {            
            if(data){
                console.log('updatevideolist');
                // this.videos = [];
                this.getResults();
            }
        });
        bus.$on('updatevideoitem', (data) => {            
            console.log('update video status data');
            console.log(data);
            if(data.new_status){
                this.updateVideoStatus(data.v_id, data.new_status.id, data.description);
            } else if (data.description != null) {
                this.updateVideoStatus(data.v_id, null, data.description);
            }
        });
    },
    computed: {
        // Passthrough only — never reset checked here (same bug as PersonsList select-all).
        videosItem(){
            return this.videos;
        },
        // disk.percent = used %. Color by free space: <10% red, <20% orange.
        diskBarClass(){
            const used = Number(this.disk.percent);
            if (!Number.isFinite(used)) {
                return '';
            }
            const free = 100 - used;
            if (free < 10) {
                return 'disk-bar--crit';
            }
            if (free < 20) {
                return 'disk-bar--warn';
            }
            return '';
        }
    },
    components: {
        Pagin,
        Dotscontrol,
        iconsort,
        hrdate,
        statusvideo,

    }
}
</script>

<style scoped>
    .tableReportNameWrap {
        max-width: 200px;
        overflow-wrap: break-word;
    }

    .video-name-link:hover {
        text-decoration: underline;
        opacity: 0.92;
    }

    #app #right_block.have_right_sitebar {
        grid-template-columns: 1fr 360px;
    }

    @media (max-width: 1840px){
        #app #right_block.have_right_sitebar {
            grid-template-columns: 1fr;
        }
    }

    .progress-bar.disk-bar--warn {
        background-color: #f0a020;
    }

    .progress-bar.disk-bar--crit {
        background-color: #d6514f;
    }
</style>
